export default "__VITE_ASSET__DySW91bE__"